import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=6159ba0f&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"
import style0 from "./Devices.vue?vue&type=style&index=0&id=6159ba0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6159ba0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardText,VIcon,VResponsive,VSkeletonLoader})
